var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_left_grey",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.29289322,0.292893219 C9.68341751,-0.0976310729 10.3165825,-0.0976310729 10.7071068,0.292893219 C11.0675907,0.65337718 11.0953203,1.22060824 10.7902954,1.61289944 L10.7071068,1.70710678 L4.415,8 L10.7071068,14.2928932 C11.0675907,14.6533772 11.0953203,15.2206082 10.7902954,15.6128994 L10.7071068,15.7071068 C10.3466228,16.0675907 9.77939176,16.0953203 9.38710056,15.7902954 L9.29289322,15.7071068 L2.29289322,8.70710678 C1.93240926,8.34662282 1.90467972,7.77939176 2.20970461,7.38710056 L2.29289322,7.29289322 L9.29289322,0.292893219 Z",
    id: "Path-28",
    fill: "#8C9BC0",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftGrey);
export default __webpack_public_path__ + "static/media/arrow_left_grey.5e48b9962b82f82a3af07c7e2ed25e0c.svg";
export { ForwardRef as ReactComponent };